export default __webpack_public_path__ + "static/media/Intro3.e3128fbc.mp3";